<template>
  <chartjs-bar-card :chartData="chartData" :chartOptions="chartOptions" class="companyProfileChart">
    <!--removing min height-->
    <template slot="header">
      <div style="display: flex; justify-content: space-between;">
        <h4 class="card-title">Company Comparison By {{ this.category.title }}</h4>
        <!-- <div class="hlpicon" v-tooltip.top-end="toolTip"><i class="fa fa-question-circle fa-lg" aria-hidden="true"></i></div> -->
        </div>
    </template>
  </chartjs-bar-card>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsBarCard } from "src/components/index";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "bar-company-comparison-chart-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsBarCard
  },
  computed: {
    ...mapGetters("charts", ["companyComparisonByProperty"]),
    ...mapGetters("user", ["currency"]),
    categoryOptions() {
      // get all of the non-numerical values
      let retval = [];
      retval = _.map(vals.GRAPH_OPTIONS, v => {
        let label = _.has(vals.HEADER_MAP, v) ? vals.HEADER_MAP[v] : _.startCase(v);
        return { label, value: v };
      });
      return _.without(retval, undefined, null);
    },
    chartData() {
      const self = this;
      let portfolioInfo = self.companyComparisonByProperty(self.companyName, self.category.selected);
      self.category.title = _.has(vals.HEADER_MAP, self.category.selected) ? vals.HEADER_MAP[self.category.selected] : _.startCase(self.category.selected);
      let labels = portfolioInfo.names;
      labels = _.map(labels, lbl => {
        return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      });
      let data = {
        labels,
        datasets: [
          {
            label: "Value",
            data: portfolioInfo.value,
            labels_unadultered: portfolioInfo.names,
            backgroundColor: "#00FFD8"
          },
          {
            label: "Cost",
            data: portfolioInfo.cost,
            labels_unadultered: portfolioInfo.names,
            backgroundColor: "#00D6FD"
          }
        ]
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          callbacks: {
            title: function(toolTips, data) {
              let toolTipItem = toolTips[0]
              return data.datasets[toolTipItem.datasetIndex].labels_unadultered[toolTipItem.index]
            },
            label: function(toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                formatCurrency(data.datasets[toolTipItem.datasetIndex].data[toolTipItem.index] || 0, self.currency.ref, 0, true)
              );
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                }
              }
            }
          ]
        }
      };
    }
  },
  data() {
    return {
      category: {
        selected: "sector",
        title: "Sector"
      }
    };
  },
  props: {
    defaultSelected: {
      type: String,
      default() {
        return undefined;
      }
    },
    companyName: {
      type: String,
      default() {return undefined}
    },
    toolTip: {
      type: String,
      default() {return "This chart shows the comparison of a company compared to others in the same category."}
    },
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  mounted() {
    const self = this;
    if (!_.isNil(self.defaultSelected)) {
      self.category.selected = self.defaultSelected;
      self.category.title = _.has(vals.HEADER_MAP, self.defaultSelected) ? vals.HEADER_MAP[self.defaultSelected] : _.startCase(self.defaultSelected);
    }
  }
};
</script>
<style>
 .hlpicon {
   color: #b3b3b3;
   cursor: pointer;
 }

  .hlpicon:hover {
   color: #0097a7;
 }
</style>